<div #spinnerModal class="modal fade spinner-overlay" tabindex="-1" role="dialog" id="spinner-modal"
     data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered text-center d-flex align-items-center justify-content-between"
         role="document">
        <div class="d-flex flex-column justify-content-center align-items-center h-100 w-100">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            @if (message) {
                <div class="mt-3"></div>
                <p class="text-white"><strong>{{ message }}</strong></p>
            }
        </div>
    </div>
</div>
